import { ACA_APPLICATION_FIELDS } from '../../submodules/aca/acaApplicationDetails';

export const LICENCE_CATEGORY = 'licence-category';

export const AMEND_ACA_APPLICATION = [
    {
        sectionID: LICENCE_CATEGORY,
        sectionName: 'Amendment Details',
        fieldList: [
            {
                id: 'amend-table',
                label: ' ',
                type: 'table',
                subFields: [
                    {
                        id: 'type',
                        header: 'I want to amend',
                        type: 'text'
                    }
                ],
                span: 12
            }
        ]
    },
    ...ACA_APPLICATION_FIELDS
];
